// Game highlights/story take until ~9am to process. Venues can stay open past midnight (until 1am/2am),
// so an entry logged in the small hours still belongs to the previous night's session and is ready
// that same calendar day at 9am, rather than the day after.
export const getStoryReadyTime = (entryDate: Date): Date => {
  const readyDate = new Date(entryDate);
  if (readyDate.getHours() < 6) {
    readyDate.setDate(readyDate.getDate() - 1);
  }
  readyDate.setDate(readyDate.getDate() + 1);
  readyDate.setHours(10, 0, 0, 0);
  return readyDate;
};
